/* -----------------Child components--------------- */
import CustomAppbar from "components/CustomAppbar";

import { appBarMeta } from "@constants/appbar";
import { pageViewTypes } from "@constants/tracking";
/* -----------------Features--------------- */
import { isWeb } from "@helpers/platform";
import useAnalytics from "@hooks/useAnalytics";
import { useDevice } from "@hooks/useDevice";
import DocumentTitle from "components/DocumentTitle";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ProgressScreen from "../screens/ProgressScreen";
const ProgressContainer = () => {
	const { isMobile } = useDevice();

	const memoizedAnalyticsParams = useMemo(() => {
		return {
			type: pageViewTypes.progress,
		};
	}, []);
	useAnalytics(memoizedAnalyticsParams);

	const finalHeaderSubtitle = isMobile ? "" : appBarMeta.progress.description;
	const { t } = useTranslation();
	return (
		<>
			<CustomAppbar
				showHambugerMenu
				showCommandBar={isWeb}
				role="banner"
				options={{
					headerTitle: t(appBarMeta.progress.title),
					subtitle: finalHeaderSubtitle,
				}}
			/>
			<DocumentTitle title="Progress" />
			<ProgressScreen />
		</>
	);
};

export default ProgressContainer;
